import type { FC } from 'react'

import type { WhiteLabel } from '@skytech/types'

import { LoaderCircle } from '../LoaderCircle'

import './styles.scss'

export const PageLoader: FC<{ whiteLabel?: WhiteLabel }> = ({ whiteLabel }) => (
  <div className="ui-page-loader">
    <LoaderCircle size="regular" whiteLabel={whiteLabel} />
  </div>
)
